import { RouteType } from "constants/RouteType"
import { MailRequestModel } from "model/utilModels/MailRequestModel";
import { RequestModel } from "model/utilModels/RequestModel";
import { AuthService } from "services/auth/AuthService";

export class RequestQuotesService {

  // To Get Request Quotes Overview List

  static getRequestQuotesList = async (requestBody: RequestModel ) => { 
    const url = RouteType.ADMIN + RouteType.REQUEST_QUOTE_LIST;
    const response = AuthService.postCryptoRequest(url, JSON.stringify(requestBody));
    return response;
  }

  // To Get The Counts Of Sending And Receiving Quotes

  static getRequestQoutesCounts = async (requestBody: RequestModel) => {
    const url = RouteType.ADMIN + RouteType.REQUEST_QUOTE_LIST + RouteType.COUNT;
    const response = AuthService.postCryptoRequest(url, JSON.stringify(requestBody));
      return response;
  }

    static addRequestQuotes = async (requestBody: MailRequestModel ) => { 
      const url = RouteType.ADMIN + RouteType.REQUEST_QUOTE + RouteType.STORE;
      const response = AuthService.postCryptoRequest(url, JSON.stringify(requestBody));
      return response;
    }

    static requestQuotesChartData = async (requestBody: RequestModel ) => { 
      const url = RouteType.ADMIN + RouteType.REQUEST_QUOTE + RouteType.COUNT_QUOTE_COUNTRY;
      const response = AuthService.postCryptoRequest(url, JSON.stringify(requestBody));
      return response;
    }

    static countUnreadQuote = async (requestBody: RequestModel ) => { 
      const url = RouteType.ADMIN + RouteType.REQUEST_QUOTE + RouteType.COUNT_UNREAD_QUOTE;
      const response = AuthService.postCryptoRequest(url, JSON.stringify(requestBody));
      return response;
    }

    static markAsReadQuotes = async (requestId: string ) => { 
      const requestBody = {"requestId":requestId}
      const url = RouteType.ADMIN + RouteType.REQUEST_QUOTE + RouteType.MARK_AS_READ;
      const response = AuthService.postCryptoRequest(url, JSON.stringify(requestBody));
      return response;
    }

    static getUnreadQuotesOnly = async (requestBody: RequestModel ) => { 
      const url = RouteType.ADMIN + RouteType.REQUEST_QUOTE + RouteType.UNREAD_QUOTE_LIST;
      const response = AuthService.postCryptoRequest(url, JSON.stringify(requestBody));
      return response;
    }
  
  }